import { TDisplayDefinitionEntryNumber } from '@internal/utils/displayDefinition/entry/DisplayDefinitionEntryNumber'
import { RangeInput } from '@renderer-ui-library/molecules'
import {
  SearchFilterCategory,
  trackRangeFilterChange,
} from '@renderer-ui-library/organisms'
import { RangeSelectValue } from 'blocks/SearchCoverBlock/RangeSelectFilter'
import { TRangeFilterValues } from 'blocks/SearchResultsBlock/TRangeFilterValues'
import { useRangeFilterOptions } from 'blocks/SearchResultsBlock/useRangeFilterOptions'
import { useSearchParams } from 'blocks/SearchResultsBlock/useSearchParams'
import { useSearchResultsRouting } from 'blocks/SearchResultsBlock/useSearchResultsRouting'
import React, { useCallback } from 'react'

type Props = {
  config: TDisplayDefinitionEntryNumber
}

export const RangeFilter: React.FC<Props> = React.memo((props) => {
  const { rangeFilters, ...searchParams } = useSearchParams()
  const { gotoSearchResults } = useSearchResultsRouting()
  const filter: TRangeFilterValues | undefined =
    rangeFilters[props.config.machineAttribute]

  const rangeFilterOptions = useRangeFilterOptions(
    props.config.machineAttribute,
    props.config.label
  )

  const handleRangeChange = useCallback(
    (value: { min?: RangeSelectValue; max?: RangeSelectValue }) => {
      gotoSearchResults({
        ...searchParams,
        rangeFilters: {
          ...rangeFilters,
          [props.config.machineAttribute]: {
            ...filter,
            ...value,
          },
        },
      })

      trackRangeFilterChange(props.config.machineAttribute, value)
    },
    [gotoSearchResults, searchParams, rangeFilters, props.config, filter]
  )

  return (
    <SearchFilterCategory title={rangeFilterOptions.label}>
      <RangeInput
        {...rangeFilterOptions}
        minValue={filter?.min}
        maxValue={filter?.max}
        step={1}
        onChange={handleRangeChange}
      />
    </SearchFilterCategory>
  )
})

RangeFilter.displayName = 'RangeFilter'
